import React from 'react'
import { WalletDesktopPage } from './wallet'

type WalletDesktopPageProps = Omit<React.ComponentProps<typeof WalletDesktopPage>, 'isCleartrip'>

const WalletDesktopFlyinContent = (props: WalletDesktopPageProps) => {
    return <WalletDesktopPage {...props} isCleartrip={false} />
}

export default WalletDesktopFlyinContent
